import { z } from 'zod';
import {
  dashboardAndAllocationFilterFormDefaultValues,
  dashboardAndAllocationFilterFormSchema,
  markerFilterDefaultValue,
  markerFilterSchema,
  nsnFilterDefaultValue,
  nsnFilterSchema,
  responseIdFilterDefaultValue,
  responseIdFilterSchema
} from 'pages/marking/schemas/shared-filter-form.schema';
import {
  commonNumberInputMax,
  commonNumberInputMin,
  commonNumberInputSchema
} from 'schemas/number.schema';

export const filterFormSchema = z.intersection(
  z.intersection(
    z.intersection(dashboardAndAllocationFilterFormSchema, nsnFilterSchema),
    z.intersection(responseIdFilterSchema, markerFilterSchema)
  ),
  z.object({
    schoolGroupName: z.string(),
    assignmentName: z.string(),
    numberOfMarkersFrom: commonNumberInputSchema,
    numberOfMarkersTo: commonNumberInputSchema,
    numberOfMarksFrom: commonNumberInputSchema,
    numberOfMarksTo: commonNumberInputSchema
  })
);

export type FilterFormValues = z.infer<typeof filterFormSchema>;

export const filterFormDefaultValues: FilterFormValues = {
  ...dashboardAndAllocationFilterFormDefaultValues,
  ...nsnFilterDefaultValue,
  ...responseIdFilterDefaultValue,
  ...markerFilterDefaultValue,
  schoolGroupName: '',
  assignmentName: '',
  numberOfMarkersFrom: commonNumberInputMin.toString(),
  numberOfMarkersTo: commonNumberInputMax.toString(),
  numberOfMarksFrom: commonNumberInputMin.toString(),
  numberOfMarksTo: commonNumberInputMax.toString()
};
